import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Login from 'components/AuthScreens/Login';
import MainApp from './MainApp';
import Register from 'components/AuthScreens/Register';
import ForgetPassword from 'components/AuthScreens/ForgetPassword';
import GoogleCallback from 'components/AuthScreens/Callback/GoogleCallback';
import ResetPassword from 'components/AuthScreens/ResetPassword';
import { SPARK_ROUTES } from 'constants/routes';
import ResourceShare from 'components/ResourceShare';

function Pages() {
  const location = useLocation();
  React.useEffect(() => {
    //@ts-ignore
    window.analytics.page();
  }, [location]);
  return (
    <Routes>
      <Route path={SPARK_ROUTES.AUTH_CALLBACK} element={<GoogleCallback />} />
      <Route path={SPARK_ROUTES.LOGIN} element={<Login />} />
      <Route path={SPARK_ROUTES.FORGOT_PASSWORD} element={<ForgetPassword />} />
      <Route path={SPARK_ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
      <Route path={SPARK_ROUTES.REGISTER} element={<Register />} />
      <Route path={SPARK_ROUTES.RESOURCE_SHARES} element={<ResourceShare />} />
      <Route path='/*' element={<MainApp />} />
    </Routes>
  );
}

export default Pages;
